export default "__VITE_PUBLIC_ASSET__f03334f6__"